module.exports = __webpack_public_path__ + "img/jianjietopmin.5237e72d.jpg";